import { AHSeparator, ListItem, useBoxStyle } from "arkh";
import React from "react";
import { FlatList } from "react-native";
import { graphql, useLazyLoadQuery } from "react-relay";

import { LazyQueryNetworkBoundrary } from "../../../components/mobile/QueryNetworkBoundrary";
import { useModalInsets } from "../../../components/mobile/useModalInsets";

import { KPICreateSubTeamScreenProps } from "./KPICreateSubTeamStack";
import { KPICreateSubTeamSelectTeamQuery } from "./__generated__/KPICreateSubTeamSelectTeamQuery.graphql";

const KPI_CREATE_SUB_TEAM_SELECT_TEAM = graphql`
  query KPICreateSubTeamSelectTeamQuery {
    currentStore @required(action: THROW) {
      publicTeams {
        id
        name
        ...ListItemTeamIndicator_team
      }
    }
  }
`;

export function KPICreateSubTeamSelectTeam(
  props: KPICreateSubTeamScreenProps<"KPICreateSubTeamSelectTeam">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <InnerKPICreateSubTeamSelectTeam {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerKPICreateSubTeamSelectTeam(
  props: KPICreateSubTeamScreenProps<"KPICreateSubTeamSelectTeam"> & {
    fetchKey: string;
  }
) {
  const data = useLazyLoadQuery<KPICreateSubTeamSelectTeamQuery>(
    KPI_CREATE_SUB_TEAM_SELECT_TEAM,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const insets = useModalInsets();
  const contentContainerStyle = useBoxStyle({
    color: "background",
    space: "medium",
    insets,
  });

  return (
    <FlatList
      contentContainerStyle={contentContainerStyle}
      ItemSeparatorComponent={AHSeparator}
      data={data.currentStore.publicTeams}
      renderItem={({ item, index }) => {
        return (
          <ListItem
            isFirst={index === 0}
            isLast={index === data.currentStore.publicTeams.length - 1}
            left={<ListItem.TeamIndicator team={item} />}
            right={<ListItem.NavArrow />}
            onPress={() => {
              props.navigation.navigateDeprecated("KPICreateSubTeamSetName", {
                ...props.route.params,
                name: "",
                teamId: item.id,
              });
            }}
          >
            <ListItem.Title>{item.name}</ListItem.Title>
          </ListItem>
        );
      }}
    />
  );
}
